import React, { useEffect, useMemo, useState } from "react";
import { RouterProvider } from "react-router-dom";
import { sentryCreateBrowserRouter } from "utils/sentry";
import ErrorPage from "components/ErrorPage";
import Skeleton from "widgets/Onboarding/components/Skeleton/Skeleton";
import LanguageProvider from "components/LanguageProvider/LanguageProvider";
import useGetTranslationFiles from "components/LanguageProvider/utils/getTranslationFiles";
import Onboarding from "./onboarding";
import { reduceStepsForValidation } from "./utils/stepManager";
import { getSplitSteps } from "./config/steps";
import useAuth from "./hooks/useAuth";

const OnboardingRouter = () => {
  const [loading, setLoading] = useState(true);
  const { user: authUser } = useAuth();
  const splitSteps = getSplitSteps(authUser);
  const steps = useMemo(() => reduceStepsForValidation(splitSteps), [splitSteps]);
  const stepRoutes = steps.map((step) => ({ path: step.path }));
  const routes = sentryCreateBrowserRouter(
    [
      {
        path: "/",
        element: <Onboarding loading={loading} steps={steps} stepList={splitSteps} />,
        children: stepRoutes,
        errorElement: <ErrorPage />,
      },
    ],
    {
      basename: "/onboarding",
    },
  );

  useEffect(() => {
    steps && routes && setLoading(false);
  }, [routes, steps]);

  const { translations, filesLoading } = useGetTranslationFiles();

  if (loading || filesLoading) {
    return <Skeleton />;
  }

  return (
    <LanguageProvider translations={translations}>
      <RouterProvider router={routes} />
    </LanguageProvider>
  );
};

export default OnboardingRouter;
